import { Stack, Typography } from '@mui/material';
import { HeaderRowProps } from '../types';

export const HeaderRow = ({ label, content }: HeaderRowProps) => (
  <Stack display="flex" flexDirection="row" gap={1}>
    <Typography color="text.disabled" variant="body2">
      {label}:
    </Typography>
    <Typography color="text.primary" variant="body2">
      {content}
    </Typography>
  </Stack>
);
